<template>
    <div class="userSearchModal">
        <b-modal size="xl"
                v-model="isModal" 
                no-close-on-backdrop 
                no-close-on-esc
                hide-header
                hide-footer>
                <div class="modal-header">
                    <h5 class="modal-title"><b>회원검색</b></h5>
                    <button type="button" class="close" @click="closeModal">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <UserSearch v-bind:queryParams="queryParams" 
                            v-bind:fullDate="fullDate"
                            v-bind:modalFalg="modalFalg" />

                <UserSelectList v-bind:items="items"
                                v-bind:listLoading="listLoading" />
        </b-modal>
    </div>
</template>
<script>
import UserSearch from "../userList/component/UserSearch";
import UserSelectList from "./UserSelectList";
import { EventBus } from "../../event-bus";

const moment = require("moment");

export default {
    name: "userSearchModal",
    props: {
        formModal: {
            type: Boolean,
        },
        modifyItem: {
            type: Object,
        }
    },
    data() {
        return {
            isModal: false,
            fullDate: [],
            queryParams: {
                name: '',
                ageRange: [],
                letter_yn: [],
                gender: [],
                grade: [],
                // pannel: [],
                industry_key: [],
                authority: [],
                user_status: [],
                employee : [],
            },
            modalFalg: true,
            items: [],
            listLoading: false,
            selItem: {},
        }
    },
    created() {
        // 이벤트 버스 선언
        EventBus.$on("callModalFindUser", (searchDate) => {
            this.fullDate = searchDate;
            this.findUser();
        });
        EventBus.$on("callSelectUser", (item) => {
            // 모달팝업 목록에서 선택된 데이터
            this.selItem = item;

            this.modifyItem.user_id = item.user_id;
            this.modifyItem.orderer_company_name = item.company_name;
            this.modifyItem.orderer_name = item.name;
            this.modifyItem.orderer_email = item.user_id;
            this.modifyItem.orderer_mobile = item.mobile;
            this.modifyItem.orderer_phone = item.phone;

            console.log('callSelectUser', this.selItem, this.modifyItem);
            this.closeModal();
        });
    },
    methods: {
        closeModal(){
            EventBus.$emit('callUserSearchCloseModal');
        },
        findUser(){
            this.listLoading = true;

            this.currentPage = 1;

            this.listLoading = true;
            this.queryParams.startDate = this.getFormatDate(this.fullDate[0]);
            this.queryParams.endDate = this.getFormatDate(this.fullDate[1]);

            this.queryParams.rowPage = 0;
            this.queryParams.currentPage = this.currentPage - 1;
            this.queryParams.downloadYn = "Y";

            this.queryParams.authority = ["NORMAL"];

            var param = encodeURI(JSON.stringify(this.queryParams));
            var data = new FormData();
            data.append("objs", param);

            this.getList(data);
        },
        getList(data) {
            var token = sessionStorage.getItem("myToken");

            this.$http
                .post("/api/select/reportUserList?access_token=" + token, data, null)
                .then((result) => {
                this.listLoading = false;
                const { resultListCount, resultList } = result.data;
                this.totalRows = resultListCount;
                this.items = [];
                this.items = resultList;
                // console.log('>>>>', this.items);
                this.listLoading = false;
                });
        },
        getFormatDate(date) {
            if (!date) return;
            return moment(date).format("YYYY-MM-DD");
        },
    },
    watch: {
        formModal: function (value, oldValue) {
            // console.log('====', value, oldValue);
            this.isModal=  this.formModal;
        },
    },
    components: {
        UserSearch,
        UserSelectList,
    }
}
</script>
<style lang="css" scoped>
.oddBackground td:nth-child(odd) {
  background:#dcdcdc;
  font-weight: 600;
  text-align: center;
}
.theader{
  background:#dcdcdc;
  font-weight: 600;
}
.tl {
    text-align: left;
}
.modal-title {
    font-size: 20px;
    font-weight: 600;
}
</style>
<style lang="css" scoped>
.userSearchModal .modal-content {
    width:1600px !important;
}
.userSearchModal .modal-xl {
    max-width: 1600px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/user/common/UserSearchModal.vue